import React, { Component } from 'react';
import { Tabs } from 'reakit';
import { Box, Flex, Heading, Text, Button } from 'rebass';
import PopupForm from '../../components/Modals/PopupForm';
import NewCategoryForm from './NewCategoryForm';
import NewScheduleForm from './NewScheduleForm';
import {
	SideTabs,
	ActiveTabCircle,
	InactiveTabCircle,
	ScheduleCard,
	TitleSection,
	ContentTabs
} from './styles';
import moment from "moment";
import { connect } from 'react-redux';
import { calendarActions, calendarSelectors } from "../../store/calendar";
const today = moment().format('YYYY-MM-DD');

class ManageCalendar extends Component {
	state = {
		toth: []
	}

	async componentDidMount() {
		const selectedDate = this.props.selectedDate === '' ? today : this.props.selectedDate;
		const tothRef = await this.props.firebase.toth().doc(selectedDate);
		const tothData = await tothRef.get();
		const generalRef = await this.props.firebase.toth().doc('general');
		const generalData = await generalRef.get();
		if (tothData.exists) {
			const data = await tothData.data();
			const genData = await generalData.data();
			const newData = this.replaceExistingData(data.data, genData.data);
			this.setState({
				toth: newData
			});

			await tothRef.set({
				data: newData
			});
		} else {
			const data = await generalData.data();
			await tothRef.set({
				data: data.data
			});
			this.setState({
				toth: data.data
			});
		}
	};

	replaceExistingData = (currentData, generalData) => {
		let newValue = currentData;

		newValue.forEach((data, parentIdx) => {
			let extraData = generalData[parentIdx]['schedules'].slice(data.schedules.length);
			newValue[parentIdx]['schedules'].push(...extraData);
		});

		let extraParentData = generalData.slice(currentData.length);
		newValue.push(...extraParentData);

		return newValue;
	};

	replaceValue = data => {
		let newValue = [];
		data.forEach(obj => {
			let newSchedule = [];
			obj.schedules.forEach(schedule => {
				newSchedule.push({
					name: schedule.name,
					details: schedule.details,
					active: false
				});
			});

			newValue.push({
				name: obj.name,
				schedules: newSchedule
			});
		});

		return newValue;
	};

	handleSaveCategory = async name => {
		const newTOTH = [...this.state.toth];
		newTOTH.push({
			name: name,
			schedules: []
		});

		this.setState({
			toth: newTOTH
		});

		const selectedDate = this.props.selectedDate === '' ? today : this.props.selectedDate;
		const tothRef = await this.props.firebase.toth().doc(selectedDate);
		await tothRef.set({
			data: newTOTH
		});

		const generalRef = await this.props.firebase.toth().doc('general');
		await generalRef.set({
			data: newTOTH
		});
	};

	handleAddNewSchedule = async data => {
		const newTOTH = [...this.state.toth];
		newTOTH[data.parentIndex].schedules.push({
			name: data.name,
			details: data.details,
			active: data.active,
		});
		this.setState({ toth: newTOTH });

		const selectedDate = this.props.selectedDate === '' ? today : this.props.selectedDate;
		const tothRef = await this.props.firebase.toth().doc(selectedDate);
		await tothRef.set({
			data: newTOTH
		});

		const generalRef = await this.props.firebase.toth().doc('general')
		await generalRef.set({
			data: this.replaceValue(newTOTH)
		});
	};

	handleEditSchedule = async data => {
		const newTOTH = [...this.state.toth];
		newTOTH[data.parentIndex].schedules[data.index] = {
			name: data.name,
			details: data.details,
			active: data.active,
		}
		this.setState({ toth: newTOTH });

		const selectedDate = this.props.selectedDate === '' ? today : this.props.selectedDate;
		const tothRef = await this.props.firebase.toth().doc(selectedDate);
		await tothRef.set({
			data: newTOTH
		});

		const generalRef = await this.props.firebase.toth().doc('general');
		await generalRef.set({
			data: this.replaceValue(newTOTH)
		});
	};

	componentWillUnmount = () => {
		this.props.updateSelectedDate('');
	}

	render() {
		const { toth } = this.state;
		const { selectedDate } = this.props;
		// const dateString = moment().format("dddd, MMM Do");
		const dateString = selectedDate === '' ? moment().format("dddd, MMM Do") : moment(selectedDate).format("dddd, MMM Do");
		return (
			<Box>
				<TitleSection>
					<Flex justifyContent={'space-between'} flexWrap={'wrap'} flexDirection={'row'}>
						<Box>
							<Heading>Today On The Hill</Heading>
							<Heading m={0} lineHeight={1} as={'h5'} color={'meta'}>{dateString}</Heading>
						</Box>
						<Button variant={'main'} onClick={() => this.props.history.goBack()}>Return</Button>
					</Flex>
				</TitleSection>
				<Tabs.Container>
					{tabs => (
						<Flex>
							<SideTabs flexDirection={'column'} justifyContent={'flex-start'}>
								<Flex justifyContent={'center'}>
									<PopupForm
										FormComponent={NewCategoryForm}
										handleSubmit={this.handleSaveCategory}
									/>
								</Flex>
								<Flex flexDirection={'column'}>
									{toth.map((obj, index) => (
										<Tabs.Tab key={index} tab={`${obj.name} + ${index}`} style={{ justifyContent: 'flex-start', margin: '12px 0' }} {...tabs}>
											{tabs.current === index ? <ActiveTabCircle /> : <InactiveTabCircle />}
											<Flex flexDirection={'column'}>
												<Heading>{obj.name}</Heading>
												<Text>
													Active: {' '}
													{obj.schedules.filter(sch => sch.active).length > 0
														? obj.schedules.filter(sch => sch.active).map(item => item.name).join(', ')
														: 'None'
													}
												</Text>
											</Flex>
										</Tabs.Tab>
									))}
								</Flex>
							</SideTabs>
							<ContentTabs p={'24px'}>
								{toth.map((obj, tothIndex) => (
									<Tabs.Panel key={tothIndex} tab={`${obj.name} + ${tothIndex}`} {...tabs}>
										<Box mb={'24px'}>
											<PopupForm
												FormComponent={NewScheduleForm}
												handleSubmit={this.handleAddNewSchedule}
												initialValues={{ parentIndex: tothIndex }}
											/>
										</Box>
										<Box>
											<Heading as={'h3'} mb={3}>Active Schedule</Heading>
											<Flex mb={'24px'} flexWrap={'wrap'}>
												{obj.schedules.map((schedule, index) => (
													schedule.active && (
														<PopupForm
															key={index}
															FormComponent={NewScheduleForm}
															handleSubmit={this.handleEditSchedule}
															initialValues={{ data: schedule, index: index, isEdit: true, parentIndex: tothIndex }}
															ShowComponent={(props) => (
																<ScheduleCard {...props}>
																	<Heading as={'h5'} lineHeight={1}>{schedule.name}</Heading>
																	<Text color={'meta'}>Click to configure</Text>
																</ScheduleCard>
															)}
														/>
													)
												))}
											</Flex>
											<Heading as={'h3'} mb={3} color={'#263039'}>Inactive Schedule</Heading>
											<Flex mb={'24px'} flexWrap={'wrap'}>
												{obj.schedules.map((schedule, index) => (
													!schedule.active && (
														<PopupForm
															key={index}
															FormComponent={NewScheduleForm}
															handleSubmit={this.handleEditSchedule}
															initialValues={{ data: schedule, index: index, isEdit: true, parentIndex: tothIndex}}
															ShowComponent={(props) => (
																<ScheduleCard {...props}>
																	<Heading as={'h5'} lineHeight={1} color={'#969a9b'}>{schedule.name}</Heading>
																	<Text color={'meta'}>Click to configure</Text>
																</ScheduleCard>
															)}
														/>
													)
												))}
											</Flex>
										</Box>
									</Tabs.Panel>
								))}
							</ContentTabs>
						</Flex>
					)}
				</Tabs.Container>
			</Box>
		);
	}
}

function mapStateToProps(state) {
	return {
		selectedDate: calendarSelectors.refreshSelectedDate(state.calendar)
	};
}

function mapDispatchToProps(dispatch) {
	return {
		updateSelectedDate: (date) => dispatch(calendarActions.updateSelectedDate(date))
	};
}
 
export default connect(mapStateToProps, mapDispatchToProps)(ManageCalendar);